import React from 'react';
import { Popover } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import FormattedDate from '../../../../components/date/FormattedDate';
import HolidayIcon from '../HolidayIcon';
import { Holiday } from './types';
import { getHolidayNameWithType } from '../AbsenceCalendar/Utils';

type Props = {
  holiday: Holiday;
};

const HolidayPopover: React.FC<React.PropsWithChildren<Props>> =
  React.forwardRef<HTMLDivElement, Props>(({ holiday, ...rest }, ref) => {
    const { t } = useTranslation();
    const popoverProps = {
      ref,
      ...rest,
    };

    const showEndDate = holiday.endDate !== holiday.startDate;
    const holidayNameWithType = getHolidayNameWithType(holiday, t);

    return (
      <Popover id={holiday.Id} {...popoverProps}>
        <Popover.Header>
          <HolidayIcon />
          <span className="ms-2">{holidayNameWithType}</span>
        </Popover.Header>
        <Popover.Body>
          <FormattedDate day={holiday.startDate} format="long" />
          {showEndDate && (
            <>
              &nbsp; - &nbsp;
              <FormattedDate day={holiday.endDate} format="long" />
            </>
          )}
        </Popover.Body>
      </Popover>
    );
  });

export default HolidayPopover;
